import { FC } from "react";
import SmartSearchDateIntervalSelectAndActionsLayout from "../../../components/Layouts/smart-search-date-interval-select-and-actions-layout";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import {
  GetCashierActivityParams,
  getCashierActivity,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import dayjs from "dayjs";

const ReportCashierActivity: FC = () => {
  return (
    <SmartSearchDateIntervalSelectAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      validOnEmpty
      actions={[ActionButtonEnum.REFRESH, ActionButtonEnum.SAVE_PDF]}
      onRefresh={(output, params, startDateInterval, endDateInterval) => {
        const getCashierActivityParams: GetCashierActivityParams = {
          output,
          beginDate: startDateInterval.format("MM/DD/YYYY"),
          endDate: endDateInterval.format("MM/DD/YYYY")
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getCashierActivityParams[id] = params.id;
        }

        return getCashierActivity(getCashierActivityParams);
      }}
    />
  );
};

export default ReportCashierActivity;
